var _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoGroups(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.61,17.29c-4.25,0-7.71-3.46-7.71-7.71S7.35,1.86,11.61,1.86s7.71,3.46,7.71,7.71-3.46,7.71-7.71,7.71Z",
    fill: filledColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33,25.13c-1,.08-3.07-1.6-3.04-2.6,.01-.39,6.32-7.19,17.44-2.82l-1.46,3.72c-8.5-3.33-12.87,1.69-12.94,1.7Z",
    fill: filledColor
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.39,17.29c-4.25,0-7.71-3.46-7.71-7.71s3.46-7.71,7.71-7.71,7.71,3.46,7.71,7.71-3.46,7.71-7.71,7.71Z",
    fill: filledColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.69,25.15c-.27-.05-4.56-5-12.95-1.71l-1.46-3.72c11.13-4.37,17.47,2.43,17.44,2.82-.08,1-2.05,2.79-3.03,2.61Z",
    fill: filledColor
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.03,37.73c-4.25,0-7.71-3.46-7.71-7.71s3.46-7.71,7.71-7.71,7.71,3.46,7.71,7.71-3.46,7.71-7.71,7.71Z",
    fill: filledColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.21,46.14s-.21-.16-.31-.24c-8.39-6.25-15.58-.07-15.99-.06-1,.02-2.67-2.05-2.59-3.05,0,0,.19-.16,.29-.24,3.63-2.89,12.2-6.25,20.78,.22,.09,.07,.28,.21,.28,.21,.23,.97-1.46,3.03-2.46,3.16Z",
    fill: filledColor
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.61,17.29c-4.25,0-7.71-3.46-7.71-7.71S7.35,1.86,11.61,1.86s7.71,3.46,7.71,7.71-3.46,7.71-7.71,7.71Zm0-11.42c-2.05,0-3.71,1.67-3.71,3.71s1.67,3.71,3.71,3.71,3.71-1.67,3.71-3.71-1.67-3.71-3.71-3.71Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.33,25.13c-1,.08-3.07-1.6-3.04-2.6,.01-.39,6.32-7.19,17.44-2.82l-1.46,3.72c-8.5-3.33-12.87,1.69-12.94,1.7Z",
    fill: outlineColor
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M36.39,17.29c-4.25,0-7.71-3.46-7.71-7.71s3.46-7.71,7.71-7.71,7.71,3.46,7.71,7.71-3.46,7.71-7.71,7.71Zm0-11.42c-2.05,0-3.71,1.67-3.71,3.71s1.67,3.71,3.71,3.71,3.71-1.67,3.71-3.71-1.67-3.71-3.71-3.71Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.69,25.15c-.27-.05-4.56-5-12.95-1.71l-1.46-3.72c11.13-4.37,17.47,2.43,17.44,2.82-.08,1-2.05,2.79-3.03,2.61Z",
    fill: outlineColor
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24.03,37.73c-4.25,0-7.71-3.46-7.71-7.71s3.46-7.71,7.71-7.71,7.71,3.46,7.71,7.71-3.46,7.71-7.71,7.71Zm0-11.42c-2.05,0-3.71,1.67-3.71,3.71s1.67,3.71,3.71,3.71,3.71-1.67,3.71-3.71-1.67-3.71-3.71-3.71Z",
    fill: outlineColor
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.21,46.14s-.21-.16-.31-.24c-8.39-6.25-15.58-.07-15.99-.06-1,.02-2.67-2.05-2.59-3.05,0,0,.19-.16,.29-.24,3.63-2.89,12.2-6.25,20.78,.22,.09,.07,.28,.21,.28,.21,.23,.97-1.46,3.03-2.46,3.16Z",
    fill: outlineColor
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 48,
    height: 48,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoGroups);
export default __webpack_public_path__ + "static/media/ico-groups.b8035a80ec98663d01b7e1b4393d2ad2.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = true;